import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Grift, Arial, sans-serif',
  },
  palette: {
    primary: {
      main: '#0d1e4a',
    },
    secondary: {
      main: '#c9a43b',
    },
  },
});

export default theme;
